<script>
import { Overlay } from '../../'
export default {
    name: 'ElderRay', mixins: [Overlay],
    methods: {
        meta_info() { return { author: 'TradingCandle', version: '1.0.0', desc: 'Elder Ray Bull and Bear Power',
            preset: { name: 'ElderRay $length', side: 'offchart',
                settings: { color: '#2962ff', colors: ['#2962ff', '#ef5350'], lineWidth: 1.5, skipNaN: true } } } },
        use_for() { return ['ElderRay'] },
        calc() { return {
            props: { length: { def: 13, text: 'Length', min: 1, step: 1 } },
            conf: { renderer: 'Splines' },
            update: `let average = ema(close, length)[0]
                    return [high[0] - average, low[0] - average]`
        } },
    },
}
</script>
